"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responses = void 0;
exports.responses = {
    accept: function () {
        return {
            status: "accept"
        };
    },
    redirect: function (path, isExternal) {
        if (isExternal === void 0) { isExternal = false; }
        return {
            status: "redirect",
            isExternal: isExternal,
            path: path
        };
    },
    reject: function (message, details) {
        if (details === void 0) { details = {}; }
        return {
            status: "reject",
            message: message,
            details: details
        };
    }
};
